
function NoPage404() {
    return <></>;
}

export default NoPage404;